import { environmentHttpClient } from "../httpClient";

export enum SettingsPageKind
{
	UserProfile = 1,
	ApplyPassword = 2,
	UserEmail = 3,
	IntegrationCredentials = 4,
	BillingInfo = 5,
	AuditLogging = 6,
	UserRequests = 7,
	UserManagement = 8,
	UserGroupManagement = 9,
	GroupPermissions = 10,
	UserProvisioning = 11,
	Licensing = 12,
	SingleSignOn = 16,
	ApiKeys = 18,
	Afas = 19,
	Autotask = 20,
	ClientlessRDP = 21,
	Egnyte = 22,
	Exchange = 23,
	FileServers = 24,
	Liquit = 25,
	Magister = 26,
	NedapOns = 27,
	Sharepoint = 29,
	TopDesk = 30,
	VilansKick = 31,
	Zaaksysteem = 32,
	Zenya = 33,
	Zermelo = 34,
	WorkspaceManagement = 35,
	Security = 36,
	Branding = 37,
	EnvironmentEmail = 38,
	FeaturePackages = 39,
	Analytics = 41,
	Sibi = 42,
	IntegrationBuilder = 43,
	GlobalSearch = 44,
	AiAssistant = 45,
	Intercom = 46,
	Nextcloud = 47
}

export type SettingsLayoutModel = {
	availablePages: readonly SettingsPageKind[];
};

export function getModel(signal?: AbortSignal): Promise<SettingsLayoutModel> {
	return environmentHttpClient.get<SettingsLayoutModel>(
		"/UiApi/SettingsLayout",
		undefined,
		{ signal }
	);
}